import { IntlShape } from 'react-intl';

export enum FORMULA_ACTIONS {
  sumDaily = 'sumDaily',
  sumMonthly = 'sumMonthly',
  sumAnnually = 'sumAnnually',
  avgDaily = 'avgDaily',
  avgMonthly = 'avgMonthly',
  avgAnnually = 'avgAnnually',
  minDaily = 'minDaily',
  minMonthly = 'minMonthly',
  minAnnually = 'minAnnually',
  maxDaily = 'maxDaily',
  maxMonthly = 'maxMonthly',
  maxAnnually = 'maxAnnually',
  dateDaily = 'dateDaily',
  dateMonthly = 'dateMonthly',
  dateAnnually = 'dateAnnually',
  onDateDaily = 'omDateDaily',
  onDateMonthly = 'onDateMonthly',
  onDateAnnually = 'onDateAnnually',
  year = 'year',
  month = 'month',
  dayOfMonth = 'dayOfMonth',
  if = 'if',
  lastMonthDaily = 'lastMonthDaily',
  lastYearDaily = 'lastYearDaily',
  lastMonthMonthly = 'lastMonthMonthly',
  lastYearMonthly = 'lastYearMonthly',
  lastYearAnnually = 'lastYearAnnually'
}

export const getFormulaActionsPlaceholder = (intl: IntlShape) => ({
  [FORMULA_ACTIONS.sumDaily]: `${intl.formatMessage({
    id: 'formula.sum',
    defaultMessage: 'SUM'
  })}(${intl.formatMessage({
    id: 'formula.reference',
    defaultMessage: 'Reference'
  })}, ${intl.formatMessage({ id: 'formula.date', defaultMessage: 'DATE' })}(${intl.formatMessage({
    id: 'formula.year',
    defaultMessage: 'year'
  })}, ${intl.formatMessage({
    id: 'common.month',
    defaultMessage: 'month'
  })}, ${intl.formatMessage({ id: 'formula.day', defaultMessage: 'day' })}), ${intl.formatMessage({
    id: 'formula.date',
    defaultMessage: 'DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })}, ${intl.formatMessage({
    id: 'common.month',
    defaultMessage: 'month'
  })}, ${intl.formatMessage({ id: 'formula.day', defaultMessage: 'day' })}))`,
  [FORMULA_ACTIONS.sumMonthly]: `${intl.formatMessage({
    id: 'formula.sum',
    defaultMessage: 'SUM'
  })}(${intl.formatMessage({
    id: 'formula.reference',
    defaultMessage: 'Reference'
  })}, ${intl.formatMessage({ id: 'formula.date', defaultMessage: 'DATE' })}(${intl.formatMessage({
    id: 'formula.year',
    defaultMessage: 'year'
  })}, ${intl.formatMessage({ id: 'common.month', defaultMessage: 'month' })}), ${intl.formatMessage({
    id: 'formula.date',
    defaultMessage: 'DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })}, ${intl.formatMessage({
    id: 'common.month',
    defaultMessage: 'month'
  })}))`,
  [FORMULA_ACTIONS.sumAnnually]: `${intl.formatMessage({
    id: 'formula.sum',
    defaultMessage: 'SUM'
  })}(${intl.formatMessage({ id: 'formula.reference', defaultMessage: 'Reference' })}, ${intl.formatMessage({
    id: 'formula.date',
    defaultMessage: 'DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })}), ${intl.formatMessage({
    id: 'formula.date',
    defaultMessage: 'DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })}))`,
  [FORMULA_ACTIONS.avgDaily]: `${intl.formatMessage({
    id: 'formula.avg',
    defaultMessage: 'AVG'
  })}(${intl.formatMessage({
    id: 'formula.reference',
    defaultMessage: 'Reference'
  })}, ${intl.formatMessage({ id: 'formula.date', defaultMessage: 'DATE' })}(${intl.formatMessage({
    id: 'formula.year',
    defaultMessage: 'year'
  })}, ${intl.formatMessage({ id: 'common.month', defaultMessage: 'month' })}, ${intl.formatMessage({
    id: 'formula.day',
    defaultMessage: 'day'
  })}), ${intl.formatMessage({
    id: 'formula.date',
    defaultMessage: 'DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })}, ${intl.formatMessage({
    id: 'common.month',
    defaultMessage: 'month'
  })}, ${intl.formatMessage({ id: 'formula.day', defaultMessage: 'day' })}))`,
  [FORMULA_ACTIONS.avgMonthly]: `${intl.formatMessage({
    id: 'formula.avg',
    defaultMessage: 'AVG'
  })}(${intl.formatMessage({
    id: 'formula.reference',
    defaultMessage: 'Reference'
  })}, ${intl.formatMessage({ id: 'formula.date', defaultMessage: 'DATE' })}(${intl.formatMessage({
    id: 'formula.year',
    defaultMessage: 'year'
  })}, ${intl.formatMessage({ id: 'common.month', defaultMessage: 'month' })}), ${intl.formatMessage({
    id: 'formula.date',
    defaultMessage: 'DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })}, ${intl.formatMessage({
    id: 'common.month',
    defaultMessage: 'month'
  })}))`,
  [FORMULA_ACTIONS.avgAnnually]: `${intl.formatMessage({
    id: 'formula.avg',
    defaultMessage: 'AVG'
  })}(${intl.formatMessage({
    id: 'formula.reference',
    defaultMessage: 'Reference'
  })}, ${intl.formatMessage({ id: 'formula.date', defaultMessage: 'DATE' })}(${intl.formatMessage({
    id: 'formula.year',
    defaultMessage: 'year'
  })}), ${intl.formatMessage({
    id: 'formula.date',
    defaultMessage: 'DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })}))`,
  [FORMULA_ACTIONS.minDaily]: `${intl.formatMessage({
    id: 'formula.min',
    defaultMessage: 'MIN'
  })}(${intl.formatMessage({
    id: 'formula.reference',
    defaultMessage: 'Reference'
  })}, ${intl.formatMessage({ id: 'formula.date', defaultMessage: 'DATE' })}(${intl.formatMessage({
    id: 'formula.year',
    defaultMessage: 'year'
  })}, ${intl.formatMessage({ id: 'common.month', defaultMessage: 'month' })}, ${intl.formatMessage({
    id: 'formula.day',
    defaultMessage: 'day'
  })}), ${intl.formatMessage({
    id: 'formula.date',
    defaultMessage: 'DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })}, ${intl.formatMessage({
    id: 'common.month',
    defaultMessage: 'month'
  })}, ${intl.formatMessage({ id: 'formula.day', defaultMessage: 'day' })}))`,
  [FORMULA_ACTIONS.minMonthly]: `${intl.formatMessage({
    id: 'formula.min',
    defaultMessage: 'MIN'
  })}(${intl.formatMessage({
    id: 'formula.reference',
    defaultMessage: 'Reference'
  })}, ${intl.formatMessage({ id: 'formula.date', defaultMessage: 'DATE' })}(${intl.formatMessage({
    id: 'formula.year',
    defaultMessage: 'year'
  })}, ${intl.formatMessage({ id: 'common.month', defaultMessage: 'month' })}), ${intl.formatMessage({
    id: 'formula.date',
    defaultMessage: 'DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })}, ${intl.formatMessage({
    id: 'common.month',
    defaultMessage: 'month'
  })}))`,
  [FORMULA_ACTIONS.minAnnually]: `${intl.formatMessage({
    id: 'formula.min',
    defaultMessage: 'MIN'
  })}(${intl.formatMessage({
    id: 'formula.reference',
    defaultMessage: 'Reference'
  })}, ${intl.formatMessage({ id: 'formula.date', defaultMessage: 'DATE' })}(${intl.formatMessage({
    id: 'formula.year',
    defaultMessage: 'year'
  })}), ${intl.formatMessage({
    id: 'formula.date',
    defaultMessage: 'DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })}))`,
  [FORMULA_ACTIONS.maxDaily]: `${intl.formatMessage({
    id: 'formula.max',
    defaultMessage: 'MAX'
  })}(${intl.formatMessage({
    id: 'formula.reference',
    defaultMessage: 'Reference'
  })}, ${intl.formatMessage({ id: 'formula.date', defaultMessage: 'DATE' })}(${intl.formatMessage({
    id: 'formula.year',
    defaultMessage: 'year'
  })}, ${intl.formatMessage({ id: 'common.month', defaultMessage: 'month' })}, ${intl.formatMessage({
    id: 'formula.day',
    defaultMessage: 'day'
  })}), ${intl.formatMessage({
    id: 'formula.date',
    defaultMessage: 'DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })}, ${intl.formatMessage({
    id: 'common.month',
    defaultMessage: 'month'
  })}, ${intl.formatMessage({ id: 'formula.day', defaultMessage: 'day' })}))`,
  [FORMULA_ACTIONS.maxMonthly]: `${intl.formatMessage({
    id: 'formula.max',
    defaultMessage: 'MAX'
  })}(${intl.formatMessage({
    id: 'formula.reference',
    defaultMessage: 'Reference'
  })}, ${intl.formatMessage({ id: 'formula.date', defaultMessage: 'DATE' })}(${intl.formatMessage({
    id: 'formula.year',
    defaultMessage: 'year'
  })}, ${intl.formatMessage({ id: 'common.month', defaultMessage: 'month' })}), ${intl.formatMessage({
    id: 'formula.date',
    defaultMessage: 'DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })}, ${intl.formatMessage({
    id: 'common.month',
    defaultMessage: 'month'
  })}))`,
  [FORMULA_ACTIONS.maxAnnually]: `${intl.formatMessage({
    id: 'formula.max',
    defaultMessage: 'MAX'
  })}(${intl.formatMessage({
    id: 'formula.reference',
    defaultMessage: 'Reference'
  })}, ${intl.formatMessage({ id: 'formula.date', defaultMessage: 'DATE' })}(${intl.formatMessage({
    id: 'formula.year',
    defaultMessage: 'year'
  })}), ${intl.formatMessage({
    id: 'formula.date',
    defaultMessage: 'DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })}))`,
  [FORMULA_ACTIONS.dateDaily]: `${intl.formatMessage({
    id: 'formula.date',
    defaultMessage: 'DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })}, ${intl.formatMessage({
    id: 'common.month',
    defaultMessage: 'month'
  })}, ${intl.formatMessage({ id: 'formula.day', defaultMessage: 'day' })})`,
  [FORMULA_ACTIONS.dateMonthly]: `${intl.formatMessage({
    id: 'formula.date',
    defaultMessage: 'DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })}, ${intl.formatMessage({
    id: 'common.month',
    defaultMessage: 'month'
  })})`,
  [FORMULA_ACTIONS.dateAnnually]: `${intl.formatMessage({
    id: 'formula.date',
    defaultMessage: 'DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })})`,
  [FORMULA_ACTIONS.onDateDaily]: `${intl.formatMessage({
    id: 'formula.on_date',
    defaultMessage: 'ON DATE'
  })}(${intl.formatMessage({
    id: 'formula.year',
    defaultMessage: 'year'
  })}, ${intl.formatMessage({ id: 'common.month', defaultMessage: 'month' })}, ${intl.formatMessage({
    id: 'formula.day',
    defaultMessage: 'day'
  })})`,
  [FORMULA_ACTIONS.onDateMonthly]: `${intl.formatMessage({
    id: 'formula.on_date',
    defaultMessage: 'ON DATE'
  })}(${intl.formatMessage({
    id: 'formula.year',
    defaultMessage: 'year'
  })}, ${intl.formatMessage({ id: 'common.month', defaultMessage: 'month' })})`,
  [FORMULA_ACTIONS.onDateAnnually]: `${intl.formatMessage({
    id: 'formula.on_date',
    defaultMessage: 'ON DATE'
  })}(${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' })})`,
  [FORMULA_ACTIONS.year]: `${intl.formatMessage({ id: 'formula.year', defaultMessage: 'year' }).toUpperCase()}()`,
  [FORMULA_ACTIONS.month]: `${intl.formatMessage({ id: 'common.month', defaultMessage: 'month' }).toUpperCase()}()`,
  [FORMULA_ACTIONS.dayOfMonth]: `${intl.formatMessage({
    id: 'formula.day_of_month',
    defaultMessage: 'DAYOFMONTH'
  })}()`,
  [FORMULA_ACTIONS.if]: `${intl.formatMessage({
    id: 'formula.if',
    defaultMessage: 'IF'
  })}(${intl.formatMessage({ id: 'formula.condition', defaultMessage: 'condition' })}=${intl.formatMessage({
    id: 'formula.true',
    defaultMessage: 'true'
  })}, ${intl.formatMessage({ id: 'formula.option_A', defaultMessage: 'option A' })}, ${intl.formatMessage({
    id: 'formula.option_B',
    defaultMessage: 'option B'
  })})`,
  [FORMULA_ACTIONS.lastMonthDaily]: `${intl.formatMessage({
    id: 'formula.last_month',
    defaultMessage: 'LASTMONTH'
  })}`,
  [FORMULA_ACTIONS.lastYearDaily]: `${intl.formatMessage({
    id: 'formula.last_year',
    defaultMessage: 'LASTYEAR'
  })}`,
  [FORMULA_ACTIONS.lastMonthMonthly]: `${intl.formatMessage({
    id: 'formula.last_month',
    defaultMessage: 'LASTMONTH'
  })}`,
  [FORMULA_ACTIONS.lastYearMonthly]: `${intl.formatMessage({
    id: 'formula.last_year',
    defaultMessage: 'LASTYEAR'
  })}`,
  [FORMULA_ACTIONS.lastYearAnnually]: `${intl.formatMessage({
    id: 'formula.last_year',
    defaultMessage: 'LASTYEAR'
  })}`
});
